export const environment = {
  production: true,
  serverUrl: 'https://api.p2p-demo.zsservices.com/',
  loginUrl: 'https://idm.staging.zsservices.com/RWDI/IdentityManager/app/web/login.aspx'
};
